export default __webpack_public_path__ + "static/media/FileCoin总部_white.f1d4f973.jpg";